import "./copybutton.scss";
import React from "react";
import FontAwesomeLight from "../../../app/Utilities/Platform/FontAwesome/FontAwesomeLight";

type Props = {
    text: string;
};

type State = {
    message: null | string;
};

export default class CopyButton extends React.Component<Props, State> {
    public state: State = {
        message: null,
    };

    public showMessage = (message: string): void => {
        this.setState({
            message,
        });
    };

    public clearMessage = (): void => {
        this.setState({
            message: null,
        });
    };

    public onClick = (): void => {
        if(navigator.clipboard) {
            navigator.clipboard.writeText(this.props.text)
                .then(() => {
                    this.showMessage("Copied");
                })
                .catch(() => {
                    this.showMessage("Failed to copy");
                });
        }
    };

    public render(): React.ReactNode {
        return (
            <div
                className="copy-button"
                onClick={this.onClick}
                onMouseLeave={this.clearMessage}
            >
                <FontAwesomeLight icon="copy" />
                {!!this.state.message && (
                    <div
                        className="copy-button-message"
                    >
                        {this.state.message}
                    </div>
                )}
            </div>
        );
    }
}
